export class DatasetCategoryDTO {
  id?: number;

  title?: string;

  defaultGroupId?: number;

  companyId?: number;

  defaultDatasetType?: string;

  defaultUnit: string = "";

  isRemote: boolean = false;

  constructor(data?: Partial<DatasetCategoryDTO>) {
    if (data) {
      Object.assign(this, data);
    }
  }

  toString(): string {
    return `${this.title}${this.isRemote ? " [R]" : ""}`;
  }
}
